module.exports = __webpack_public_path__ + "img/zelle-payment.svg";